import { ReactElement, ReactNode } from 'react';
import { Button, Dropdown, DropDownProps } from 'antd';
import { PlusSquare } from 'react-feather';

interface Props extends Omit<DropDownProps, 'overlay'> {
  children?: ReactNode;
  disabled?: boolean;
  loading?: boolean;
}

function DefaultPlusSquareDropdown({ children, disabled, ...rest }: Props) {
  return (
    <Dropdown
      {...rest}
      disabled={disabled}
      overlay={children as ReactElement}
      trigger={['click']}
    >
      <Button icon={<PlusSquare size="21" />} type="link" />
    </Dropdown>
  );
}

export default DefaultPlusSquareDropdown;
